import React from "react";
import ChatHistoryIcon from "../../assets/images/chat-history.svg";
import CollapseIcon from "../../assets/images/collapse_icon.svg";
import ExpandIcon from "../../assets/images/expand_icon.svg";
import AiAssistantCloseNewIcon from "../../assets/images/ai_assistant_close_icon_new.svg";
import { withTranslation } from "react-i18next";

function ChatboxHeader({
  t,
  isExpanded,
  setIsExpanded,
  showSidebar,
  setShowSidebar,
  profile,
}) {
  return (
    <div className="chatbox-header">
      {profile?.isAiPrivacyPolicyAccepted ? (
        <img
          src={showSidebar ? AiAssistantCloseNewIcon : ChatHistoryIcon}
          alt="ToggleSidebar"
          className="chat-history-btn"
          onClick={() => setShowSidebar((prev) => !prev)}
          style={{ cursor: "pointer" }}
        />
      ) : (
        <div className="invisible-placeholder"></div>
      )}

      <h4 className="header_title">{t("aiAssistant.chatBotHeading")}</h4>

      <button
        className="expand-btn"
        onClick={() => setIsExpanded((prev) => !prev)}
      >
        <img
          src={isExpanded ? CollapseIcon : ExpandIcon}
          alt={isExpanded ? "Collapse" : "Expand"}
        />
      </button>
    </div>
  );
}

export default withTranslation()(ChatboxHeader);
